<template>
    <div class="section-content">
        <span :class="'one ' +(icon ||' one-smart')"/>
        <label class="title-container">
            <span class="title-text">{{title}}</span>
        </label>
        <span class="tip-content">
            <div v-for="(item,index) in contents" class="tip-item">
                <span class="tip-item-number">{{index+1}}.</span>
                <span class="tip-item-content">{{item.text}}</span>
            </div>
        </span>
    </div>
</template>

<script>
    export default {
        name: "SectionContent",
        props: {tip: String, title: String, icon: String,contents:Array}
    }
</script>

<style scoped lang="scss">
    .section-content {
        color: #ED6C00;
        font-weight: 600;
        text-align: left;
        width: 727px;
        .title-container {
            display: inline-block;
            width: 680px;
            padding-bottom: 8px;

            .title-text {
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                color: #ED6C00;
                border-bottom: 2px solid #ED6C00;
                padding-bottom: 8px;
            }
            .one{
                font-size: 16px;
            }

            border-bottom: 1px solid #C4C4C4;
        }

        .tip-content {
            display: block;
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            color: #6A6A6A;
            padding: 20px 0px 20px 30px;
            .tip-item{
                margin-bottom: 17px;
                font-size: 13px;
                line-height: 19px;
                color: #444444;
                .tip-item-number{
                    display: inline-block;
                    margin-right: 10px;
                    vertical-align: top;
                }
                .tip-item-content{
                    display: inline-block;
                    width: 660px;
                }
            }
        }

        .one {
            color: #ED6C00;
            font-size: 20px;
            position: relative;
            top: 4px;
            left: 4px;
            margin-right: 9px;
        }
    }
</style>